import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { animationParams, animationVariants } from 'fragments';
import { PowerfulFeaturesCard } from './powerfulFeaturesCard';
import { powerfulFeaturesCardData } from '../constants';
import { IsImageLoaded } from 'utils';
import { landingImages, LandingSvg } from 'assets';

export const PowerfulFeatures = () => {
    const navigate = useNavigate();
    const beckLoaded = IsImageLoaded(landingImages.bannerImg);

    return (
        <div
            className="powerful-features-wrapper"
            style={{
                backgroundImage: `url(${beckLoaded ? landingImages.bannerImg : landingImages.bannerImgSmall})`,
                backgroundSize: '100% 100%',
            }}
        >
            <div className="container">
                <div className="powerful-features-box">
                    <div style={{ overflow: 'hidden' }}>
                        <motion.h2 className="powerful-features-title" {...animationParams} variants={animationVariants.titleVariant}>
                            Powerful Features for Your Practice
                        </motion.h2>
                    </div>

                    <div style={{ overflow: 'hidden' }}>
                        <motion.p className="powerful-features-text" {...animationParams} variants={animationVariants.titleVariant}>
                            Everything you need to manage your ABA practice and deliver exceptional clinical care, organized into two
                            powerful modules.
                        </motion.p>
                    </div>

                    <div className="powerful-features-cards-position">
                        <div className="powerful-features-beck-svg">
                            <img src={landingImages.vectorImg} alt="vector" style={{ width: '100%', height: '100%' }} />
                        </div>

                        <div className="powerful-features-cards-header">
                            <motion.p
                                className="powerful-features-cards-header-title"
                                {...animationParams}
                                variants={animationVariants.titleVariant}
                                style={{ color: '#8FB9F2' }}
                            >
                                Practice Management
                            </motion.p>

                            <button
                                style={{ zIndex: 2, position: 'relative' }}
                                className="all-features-btn"
                                onClick={() => navigate('/practice')}
                            >
                                View all
                                <LandingSvg.ArrowRightSvg className="arrow-right" />
                            </button>
                        </div>

                        <div className="powerful-features-cards-wrapper features-cards-wrapper-first">
                            {powerfulFeaturesCardData.practiceManagement.map((item, index) => (
                                <motion.div
                                    key={index}
                                    className="powerful-feature-cards-block"
                                    {...animationParams}
                                    variants={animationVariants.cardsVariant}
                                >
                                    <PowerfulFeaturesCard {...item} key={index} />
                                </motion.div>
                            ))}
                        </div>

                        <div className="powerful-features-cards-header">
                            <motion.p
                                className="powerful-features-cards-header-title"
                                {...animationParams}
                                variants={animationVariants.titleVariant}
                                style={{ color: '#E9D7FE' }}
                            >
                                DATA COLLECTION
                            </motion.p>

                            <button
                                className="all-features-btn"
                                onClick={() => navigate('/data-collection')}
                                style={{ color: '#E9D7FE' }}
                            >
                                View all
                                <LandingSvg.ArrowRightSvg
                                    className="arrow-right"
                                    style={{
                                        filter: 'brightness(0) saturate(100%) invert(85%) sepia(20%) saturate(974%) hue-rotate(199deg) brightness(104%) contrast(99%)',
                                    }}
                                />
                            </button>
                        </div>

                        <div className="powerful-features-cards-wrapper">
                            {powerfulFeaturesCardData.dataCollection.map((item, index) => (
                                <motion.div
                                    key={index}
                                    className="powerful-feature-cards-block"
                                    {...animationParams}
                                    variants={animationVariants.cardsVariant}
                                >
                                    <PowerfulFeaturesCard
                                        {...item}
                                    />
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
